import React from "react";
import PropTypes from "prop-types";
import styles from "./PortalPreloader.module.css";

/**
 * Écran de chargement de l'espace voyageur.
 *
 * Remplace le badge dessiné à la main de `common/preLoader/PreLoader`, qui ne
 * correspondait à aucun logo du produit. Le back-office garde l'ancien : il
 * n'est pas dans le périmètre de la refonte.
 *
 * Le logo est un PNG — il n'existe pas de version vectorielle du monogramme.
 * Conséquence : on ne peut plus animer un tracé, seulement une respiration.
 * `index.html` le précharge pour qu'il soit là dès la première image.
 *
 * La barre est indéterminée : rien ne permet de connaître l'avancement réel
 * de Keycloak et d'Apollo, et afficher un pourcentage inventé serait faux.
 */
export const PortalPreloader = ({ label = "Chargement" }) => (
  <div
    className={styles.preloader}
    role="status"
    aria-live="polite"
    aria-label={label}
  >
    <div className={styles.content}>
      <img
        className={styles.logo}
        src="/mondoviva-logo.png"
        alt=""
        width="112"
        height="112"
        /* Le preloader est la première chose affichée : pas de lazy. */
        fetchpriority="high"
      />

      <div className={styles.progress}>
        <span className={styles.label}>{label}</span>
        <span className={styles.track}>
          <span className={styles.fill} />
        </span>
      </div>
    </div>
  </div>
);

PortalPreloader.propTypes = {
  /** Texte annoncé aux lecteurs d'écran et affiché sous le logo. */
  label: PropTypes.string,
};

export default PortalPreloader;
